import { Injectable, EventEmitter, Output } from '@angular/core';
import { SocialMediaPostForBoard} from '../../modele/boardModel';
import {Observable, of} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class PlaylistService {
    @Output() returnPlaylistEmitter: EventEmitter<Array<SocialMediaPostForBoard>> = new EventEmitter();
    @Output() returnAktivTrackEmitter: EventEmitter<Array<SocialMediaPostForBoard>> = new EventEmitter();
    private track_list: Array<SocialMediaPostForBoard> = [];

  constructor() { }

  addTrackToPlaylist(newTrack) {
      this.track_list.push(newTrack)
      this.returnPlaylistEmitter.emit(this.track_list);
  }
  playTrack(newTrack) {
      this.returnAktivTrackEmitter.emit(newTrack)
  }

  public getPlaylistEmitter(): EventEmitter<Array<SocialMediaPostForBoard>> {
         return this.returnPlaylistEmitter;
  }
  public getAktivTrackFromPlaylistEmitter(): EventEmitter<Array<SocialMediaPostForBoard>> {
         return this.returnAktivTrackEmitter;
  }

}
